import React from 'react'
import { Typography } from '@mui/material'

interface ReleaseIntroProps {
  text: string
}

export const ReleaseIntro: React.FC<ReleaseIntroProps> = ({ text }) => {
  if (!text) return null
  return (
    <Typography
      sx={{
        width: '100%',
        fontSize: '0.95rem',
        lineHeight: 1.5,
        color: 'rgba(0,0,0,0.78)',
        py: 1,
      }}
    >
      {text}
    </Typography>
  )
}

export default ReleaseIntro
